module.exports = __webpack_public_path__ + "media/images/proof_links/snapchat-ecac81f0ae33e62ef73d9ce89f968cae.svg";